import useVapState from './hooks/useVapState';
import { styled } from 'styled-components';
import HeaderBar from './components/header/HeaderBar';
import MainPage from './pages/MainPage';
import SelectionPage from './pages/SelectionPage';
import { useEffect, useMemo } from 'react';

function App() {
  const vapState = useVapState();

  const fileFromQuery = useMemo(() => {
    const file = new URLSearchParams(window.location.search).get('file');
    return file?.trim() || null;
  }, []);

  useEffect(() => {
    if (fileFromQuery) {
      vapState.loadFromUrl(fileFromQuery);
    }
  }, [fileFromQuery, vapState.loadFromUrl]);

  // Matomo
  useEffect(() => {
    //@ts-ignore
    var _paq = window._paq = window._paq || [];
    /* tracker methods like "setCustomDimension" should be called before "trackPageView" */
    _paq.push(['trackPageView']);
    _paq.push(['enableLinkTracking']);
    (function() {
      var u = "//" + import.meta.env.VITE_TRACKER_URL + "/";
      _paq.push(['setTrackerUrl', u+'matomo.php']);
      _paq.push(['setSiteId', import.meta.env.VITE_TRACKER_ID]);
      _paq.push(['setCustomDimension', 1, (window.location.pathname.split("/")[1].toString() || "0")])
      var d=document, g=d.createElement('script'), s=d.getElementsByTagName('script')[0];
      g.async=true; g.src=u+'matomo.js'; s.parentNode?.insertBefore(g,s);
    })();
  }, [])
  
  // Show selection page when no file is loaded and no file query param
  if (vapState.assets.length === 0 && !vapState.isLoading && !fileFromQuery) {
    // vapState.loadFromUrl("https://store.fms.staging.ugla.tech/public/demoCosika/demo_vap_multiple_views.json")
    return (
      <SelectionPage state={vapState}/>
      // <AppContainer>
      //   <FileLoader
      //     onFileLoad={vapState.loadFromFile}
      //     onUrlLoad={vapState.loadFromUrl}
      //     isLoading={vapState.isLoading}
      //     error={vapState.error}
      //   />
      // </AppContainer>
    );
  }


  // Show main layout when file is loaded
  return (
      <AppContainer>
        <HeaderBar title={vapState.currentModel}/>
        <MainPage vapState={vapState}/>
      </AppContainer>
  );
}

const AppContainer = styled.div`
  width: 100%;
  height: 100%;
  overflow: hidden;
  padding: 1vh 1vw;
  display: flex;
  flex-direction: column;
`;

export default App;
